import { appConfig } from "../config";
import NeoAPI from "./NeoAPI.js";

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let response = await originalFetch(resource, config);
  const token = localStorage.getItem("fmsToken");
  if (!response.ok && response.status === 401 && token != null) {
    localStorage.clear();

    window.location.hash = "/login";
  }
  return response;
};

// const Society = {};  // Dynamic and centrally shared

async function postLogInApi(loginData) {
  const default_login_response = {
    society_name: "",
    userrole: "societyadmin",
    token_type: "bearer",
    message: "",
    error: "",
    access_token: "",
    refresh_token: "",
    society_id: null,
    scope: "",
    expires_in: 0,
    currencyLocaleString: "Rs. ",
    jti: "",
    email: "",
    username: loginData.username,
    status: "Success",
  };

  try {
    const neoLoginResponse = await NeoAPI.login(
      loginData.username,
      loginData.password
    ); // ✅ await here
    if (neoLoginResponse.status == "ok") {
      // Set values based on login response
      default_login_response.society_name = neoLoginResponse.property;
      default_login_response.society_id = neoLoginResponse.property; // if ID is available separately, use it
      return default_login_response;
    } else {
      return {
        message: "Invalid credentials",
        error:
          '400 : "{"error":"invalid_grant","error_description":"Bad credentials"}"',
        status: "Failed",
      };
    }
  } catch (error) {
    console.error("Login API error", error);
    throw error;
  }
}

// Fetch society profile API
function* fetchProfileApi(data) {
  // Default profile response structure
  const default_response = {
    response_data: {
      blockPortal: 0,
      address: "",
      sendAlerts: 0,
      billRoundoff: 0,
      emailId: "",
      quotaOption: 0,
      onlinebillPayment: 0,
      phone: "",
      quotaEnable: 0,
      primaryContact: "",
      name: "",
      aptconsextraCol: 0,
      status: "operation",
    },
    message: "",
    error: "",
    status: "Success",
  };
  const neoProfileResponse = NeoAPI.getPropertyData();
  // {"response_data":{"blockPortal":0,"address":"655/261, Borewell Road, Whitefield, Bangalore","sendAlerts":0,"billRoundoff":0,"emailId":"","quotaOption":0,"onlinebillPayment":0,"phone":"9900241337","quotaEnable":0,"primaryContact":"Vivek Kappor","name":"Chelli Poise","aptconsextraCol":0,"status":"operation"},"message":"","error":"","status":"Success"}

  try {
    default_response.response_data.name = neoProfileResponse.property;

    return JSON.parse(JSON.stringify(default_response));
  } catch (error) {
    throw error;
  }
}
// Fetch society RWA Status with localStorage caching

function* fetchRwaStatusApi(data) {
  const societyId = data.societyId;

  // Create the static response using societyId
  const response = {
    response_data: {
      societyId: String(societyId), // ensure it's a string
      status: true, // hardcoded true as per your example
    },
    message: "",
    error: "",
    status: "Success",
  };

  return response;
}

function* fetchApartmentCountApi(data) {
  const default_response = {
    response_data: {
      apts: [],
      societyId: "",
      count: 0,
      type: "All",
    },
    message: "",
    error: "",
    status: "Success",
  };

  const property = NeoAPI.getPropertyData();

  if (!property || !property.units) {
    default_response.message = "No property data found.";
    default_response.error = "Invalid property structure.";
    default_response.status = "Fail";
    return JSON.parse(JSON.stringify(default_response));
  }

  const units = property.units;
  const uinfo = property.uinfo;

  const apts = [];
  const count = Object.keys(units).length;
  const uinfoCount = Object.keys(uinfo).length;

  for (const unitName in units) {
    const unit = units[unitName];
    const residents = unit.residents || [];

    let owner = null;
    let lastOwner = null;
    let tenant = null;
    let lastTenant = null;

    for (let res of residents) {
      if (res.residentType === "Owner") {
        lastOwner = res;
        if (res.residentName && res.residentName.trim()) {
          owner = res;
        }
      } else if (res.residentType === "Tenant") {
        lastTenant = res;
        if (res.residentName && res.residentName.trim()) {
          tenant = res;
        }
      }
    }

    // Fallbacks
    owner = owner || lastOwner;
    tenant = tenant || lastTenant;

    // If no tenant present, owner is also default resident
    const resident = tenant || owner;

    // 🔹 Determine lockStatus based on has_valve
    let lockStatus = "NA";
    const meterLocations = unit.meterLocations || {};

    for (const loc in meterLocations) {
      const meter = meterLocations[loc];
      if (meter.has_valve === 1 || meter.has_valve === "1") {
        lockStatus = "Open";
        break;
      }
    }
    if (uinfoCount > 0) {
      const uinfoItem = uinfo[unitName];

      if (uinfoItem) {
        if (uinfoItem.admin_lock) lockStatus = "Close";
        else lockStatus = "Open";
      }
    }

    const apartment = {
      aptId: unitName,
      aptNo: unitName,
      towerName: "All",
      lockStatus,

      // Owner
      ownerName: owner?.residentName || "",
      ownerPhone: owner?.phone || "",
      ownerEmail: owner?.email || "",
      isappuserowner:
        owner?.appUser === "1" || owner?.appUser === 1 ? true : false,

      // Resident (owner if tenant missing)
      residentName: resident?.residentName || "",
      residentPhone: resident?.phone || "",
      residentEmail: resident?.email || "",
      isappuserresident:
        resident?.appUser === "1" || resident?.appUser === 1 ? true : false,

      comment: null,
    };

    apts.push(apartment);
  }

  default_response.response_data.apts = apts;
  default_response.response_data.societyId = property?.property || "";
  default_response.response_data.count = count;

  const retVal = JSON.parse(JSON.stringify(default_response));
  return retVal;
}

// // Fetch society apartment with localStorage caching

// function* fetchApartmentCountApi(data) {
//   const default_response = {
//     response_data: {
//       apts: [],
//       societyId: "",
//       count: 0,
//       type: "All"
//     },
//     message: "",
//     error: "",
//     status: "Success"
//   };

//   const property = NeoAPI.getPropertyData();
//   const units = property.units;

//   const apts = [];
//   const count = Object.keys(units).length;

//   for (const unit in units) {
//     const apartment = {
//       isappuserowner: true,
//       ownerPhone: "",
//       residentPhone: "",
//       aptId: unit,
//       aptNo: unit,
//       ownerEmail: "",
//       isappuserresident: true,
//       ownerName: "",
//       lockStatus: "Open",
//       residentName: "",
//       residentEmail: "",
//       comment: null,
//       towerName: "All"
//     };

//     apts.push(apartment);
//   }

//   default_response.response_data.apts = apts;
//   default_response.response_data.societyId = property.property;
//   default_response.response_data.count = count;
//   return JSON.parse(JSON.stringify(default_response));
//   // sampleRequest = {"societyId":"814","filter":"Total","type":"All"}
//   // sampleRequest = {"response_data":{"apts":[{"isappuserowner":true,"ownerPhone":"91-9845638881","residentPhone":"91-9845638881","aptId":"35972","aptNo":"1A & 1B","ownerEmail":"meghana.hegde@gmail.com","isappuserresident":true,"ownerName":"Meghana","lockStatus":"Open","residentName":"Meghana","residentEmail":"meghana.hegde@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9900733055","residentPhone":"91-9900733055","aptId":"35973","aptNo":"2A & 2B","ownerEmail":"rkakeshav@yahoo.com","isappuserresident":true,"ownerName":"Keshav","lockStatus":"Open","residentName":"Keshav","residentEmail":"rkakeshav@yahoo.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9945204907","residentPhone":"91-9945204907","aptId":"35974","aptNo":"3A","ownerEmail":"avi.d84@gmail.com","isappuserresident":true,"ownerName":"Vivekanandan","lockStatus":"Open","residentName":"Vivekanandan","residentEmail":"avi.d84@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-8088167742","residentPhone":"91-8088167742","aptId":"35975","aptNo":"4A","ownerEmail":"g3.selva@gmail.com","isappuserresident":true,"ownerName":"Gayathri","lockStatus":"Open","residentName":"Gayathri","residentEmail":"g3.selva@gmail.com","comment":"Empty house","towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-7250919969","residentPhone":"91-7250919969","aptId":"35976","aptNo":"3B & 4B","ownerEmail":"pk480890@gmail.com","isappuserresident":true,"ownerName":"Prashant Kumar","lockStatus":"Open","residentName":"Prashant Kumar","residentEmail":"pk480890@gmail.com","comment":"Water leak","towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-8884567071","residentPhone":"91-8884567071","aptId":"35977","aptNo":"1C","ownerEmail":"shivaa17@yahoo.co.in","isappuserresident":true,"ownerName":"Sivaraman ","lockStatus":"Open","residentName":"Sivaraman ","residentEmail":"shivaa17@yahoo.co.in","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9639460660","residentPhone":"91-9639460660","aptId":"35978","aptNo":"2C","ownerEmail":"ankiit.bahuguna@gmail.com","isappuserresident":true,"ownerName":"Ankit Bahuguna","lockStatus":"Open","residentName":"Ankit Bahuguna","residentEmail":"ankiit.bahuguna@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"65-94596578","residentPhone":"65-94596578","aptId":"35979","aptNo":"3C","ownerEmail":"chetanghotekar@gmail.com","isappuserresident":true,"ownerName":"Chetan","lockStatus":"Open","residentName":"Chetan","residentEmail":"chetanghotekar@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9676651747","residentPhone":"91-9676651747","aptId":"35980","aptNo":"4C","ownerEmail":"anandgaurav812@gmail.com","isappuserresident":true,"ownerName":"Gaurav","lockStatus":"Open","residentName":"Gaurav","residentEmail":"anandgaurav812@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9632499911","residentPhone":"91-9632499911","aptId":"35981","aptNo":"1D","ownerEmail":"rajkps4@gmail.com","isappuserresident":true,"ownerName":"Rajesh ","lockStatus":"Open","residentName":"Rajesh ","residentEmail":"rajkps4@gmail.com","comment":"No Comments","towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9900241337","residentPhone":"91-9900241337","aptId":"35982","aptNo":"2D","ownerEmail":"vivekkapoor1973@gmail.com","isappuserresident":true,"ownerName":"Vivek","lockStatus":"Open","residentName":"Vivek","residentEmail":"vivekkapoor1973@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9986206223","residentPhone":"91-9986206223","aptId":"35983","aptNo":"3D","ownerEmail":"desikanv@gmail.com","isappuserresident":true,"ownerName":"Desikan","lockStatus":"Open","residentName":"Desikan","residentEmail":"desikanv@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-8792652365","residentPhone":"91-8792652365","aptId":"35984","aptNo":"4D","ownerEmail":"ashish.jadaun@live.com","isappuserresident":true,"ownerName":"Ashish","lockStatus":"Open","residentName":"Ashish","residentEmail":"ashish.jadaun@live.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-7005360367","residentPhone":"91-7005360367","aptId":"35985","aptNo":"1E","ownerEmail":"rahulbhadra199707@gmail.com","isappuserresident":true,"ownerName":"Rahul Bhadra","lockStatus":"Close","residentName":"Rahul Bhadra","residentEmail":"rahulbhadra199707@gmail.com","comment":"Empty house","towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9449986365","residentPhone":"91-9449986365","aptId":"35986","aptNo":"2E","ownerEmail":"george.chandru@gmail.com","isappuserresident":true,"ownerName":"Chandra","lockStatus":"Open","residentName":"Chandra","residentEmail":"george.chandru@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9900249360","residentPhone":"91-9900249360","aptId":"35987","aptNo":"3E","ownerEmail":"tnravi2@gmail.com","isappuserresident":true,"ownerName":"Ravi","lockStatus":"Open","residentName":"Ravi","residentEmail":"tnravi2@gmail.com","comment":"Regular Leak alarms","towerName":"All"},{"isappuserowner":false,"ownerPhone":"91-7397119607","residentPhone":"49-17664297132","aptId":"35988","aptNo":"4E","ownerEmail":"durga60@gmail.com","isappuserresident":true,"ownerName":"Durga","lockStatus":"Open","residentName":"Durga","residentEmail":"durga60@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9987962178","residentPhone":"91-9987962178","aptId":"35989","aptNo":"1F","ownerEmail":"itarpit.raj178@gmail.com","isappuserresident":true,"ownerName":"Arpit Raj","lockStatus":"Open","residentName":"Arpit Raj","residentEmail":"itarpit.raj178@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9742447734","residentPhone":"91-9742447734","aptId":"35990","aptNo":"2F","ownerEmail":"prasanna_ramanujam@yahoo.com","isappuserresident":true,"ownerName":"Prasanna","lockStatus":"Open","residentName":"Prasanna","residentEmail":"prasanna_ramanujam@yahoo.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9916484134","residentPhone":"91-9916484134","aptId":"35991","aptNo":"3F","ownerEmail":"jyotimsingh@gmail.com","isappuserresident":true,"ownerName":"Jyoti","lockStatus":"Open","residentName":"Jyoti","residentEmail":"jyotimsingh@gmail.com","comment":null,"towerName":"All"},{"isappuserowner":true,"ownerPhone":"91-9606562707","residentPhone":"91-9606562707","aptId":"35992","aptNo":"4F","ownerEmail":"zfshaikh@gmail.com","isappuserresident":true,"ownerName":"Sarah","lockStatus":"Open","residentName":"Sarah","residentEmail":"zfshaikh@gmail.com","comment":null,"towerName":"All"}],"societyId":"814","count":21,"type":"All"},"message":"","error":"","status":"Success"}
//   // return { "response_data": { "apts": [{ "isappuserowner": true, "ownerPhone": "91-9845638881", "residentPhone": "91-9845638881", "aptId": "35972", "aptNo": "1A & 1B", "ownerEmail": "meghana.hegde@gmail.com", "isappuserresident": true, "ownerName": "Meghana", "lockStatus": "Open", "residentName": "Meghana", "residentEmail": "meghana.hegde@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9900733055", "residentPhone": "91-9900733055", "aptId": "35973", "aptNo": "2A & 2B", "ownerEmail": "rkakeshav@yahoo.com", "isappuserresident": true, "ownerName": "Keshav", "lockStatus": "Open", "residentName": "Keshav", "residentEmail": "rkakeshav@yahoo.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9945204907", "residentPhone": "91-9945204907", "aptId": "35974", "aptNo": "3A", "ownerEmail": "avi.d84@gmail.com", "isappuserresident": true, "ownerName": "Vivekanandan", "lockStatus": "Open", "residentName": "Vivekanandan", "residentEmail": "avi.d84@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-8088167742", "residentPhone": "91-8088167742", "aptId": "35975", "aptNo": "4A", "ownerEmail": "g3.selva@gmail.com", "isappuserresident": true, "ownerName": "Gayathri", "lockStatus": "Open", "residentName": "Gayathri", "residentEmail": "g3.selva@gmail.com", "comment": "Empty house", "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-7250919969", "residentPhone": "91-7250919969", "aptId": "35976", "aptNo": "3B & 4B", "ownerEmail": "pk480890@gmail.com", "isappuserresident": true, "ownerName": "Prashant Kumar", "lockStatus": "Open", "residentName": "Prashant Kumar", "residentEmail": "pk480890@gmail.com", "comment": "Water leak", "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-8884567071", "residentPhone": "91-8884567071", "aptId": "35977", "aptNo": "1C", "ownerEmail": "shivaa17@yahoo.co.in", "isappuserresident": true, "ownerName": "Sivaraman ", "lockStatus": "Open", "residentName": "Sivaraman ", "residentEmail": "shivaa17@yahoo.co.in", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9639460660", "residentPhone": "91-9639460660", "aptId": "35978", "aptNo": "2C", "ownerEmail": "ankiit.bahuguna@gmail.com", "isappuserresident": true, "ownerName": "Ankit Bahuguna", "lockStatus": "Open", "residentName": "Ankit Bahuguna", "residentEmail": "ankiit.bahuguna@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "65-94596578", "residentPhone": "65-94596578", "aptId": "35979", "aptNo": "3C", "ownerEmail": "chetanghotekar@gmail.com", "isappuserresident": true, "ownerName": "Chetan", "lockStatus": "Open", "residentName": "Chetan", "residentEmail": "chetanghotekar@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9676651747", "residentPhone": "91-9676651747", "aptId": "35980", "aptNo": "4C", "ownerEmail": "anandgaurav812@gmail.com", "isappuserresident": true, "ownerName": "Gaurav", "lockStatus": "Open", "residentName": "Gaurav", "residentEmail": "anandgaurav812@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9632499911", "residentPhone": "91-9632499911", "aptId": "35981", "aptNo": "1D", "ownerEmail": "rajkps4@gmail.com", "isappuserresident": true, "ownerName": "Rajesh ", "lockStatus": "Open", "residentName": "Rajesh ", "residentEmail": "rajkps4@gmail.com", "comment": "No Comments", "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9900241337", "residentPhone": "91-9900241337", "aptId": "35982", "aptNo": "2D", "ownerEmail": "vivekkapoor1973@gmail.com", "isappuserresident": true, "ownerName": "Vivek", "lockStatus": "Open", "residentName": "Vivek", "residentEmail": "vivekkapoor1973@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9986206223", "residentPhone": "91-9986206223", "aptId": "35983", "aptNo": "3D", "ownerEmail": "desikanv@gmail.com", "isappuserresident": true, "ownerName": "Desikan", "lockStatus": "Open", "residentName": "Desikan", "residentEmail": "desikanv@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-8792652365", "residentPhone": "91-8792652365", "aptId": "35984", "aptNo": "4D", "ownerEmail": "ashish.jadaun@live.com", "isappuserresident": true, "ownerName": "Ashish", "lockStatus": "Open", "residentName": "Ashish", "residentEmail": "ashish.jadaun@live.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-7005360367", "residentPhone": "91-7005360367", "aptId": "35985", "aptNo": "1E", "ownerEmail": "rahulbhadra199707@gmail.com", "isappuserresident": true, "ownerName": "Rahul Bhadra", "lockStatus": "Close", "residentName": "Rahul Bhadra", "residentEmail": "rahulbhadra199707@gmail.com", "comment": "Empty house", "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9449986365", "residentPhone": "91-9449986365", "aptId": "35986", "aptNo": "2E", "ownerEmail": "george.chandru@gmail.com", "isappuserresident": true, "ownerName": "Chandra", "lockStatus": "Open", "residentName": "Chandra", "residentEmail": "george.chandru@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9900249360", "residentPhone": "91-9900249360", "aptId": "35987", "aptNo": "3E", "ownerEmail": "tnravi2@gmail.com", "isappuserresident": true, "ownerName": "Ravi", "lockStatus": "Open", "residentName": "Ravi", "residentEmail": "tnravi2@gmail.com", "comment": "Regular Leak alarms", "towerName": "All" }, { "isappuserowner": false, "ownerPhone": "91-7397119607", "residentPhone": "49-17664297132", "aptId": "35988", "aptNo": "4E", "ownerEmail": "durga60@gmail.com", "isappuserresident": true, "ownerName": "Durga", "lockStatus": "Open", "residentName": "Durga", "residentEmail": "durga60@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9987962178", "residentPhone": "91-9987962178", "aptId": "35989", "aptNo": "1F", "ownerEmail": "itarpit.raj178@gmail.com", "isappuserresident": true, "ownerName": "Arpit Raj", "lockStatus": "Open", "residentName": "Arpit Raj", "residentEmail": "itarpit.raj178@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9742447734", "residentPhone": "91-9742447734", "aptId": "35990", "aptNo": "2F", "ownerEmail": "prasanna_ramanujam@yahoo.com", "isappuserresident": true, "ownerName": "Prasanna", "lockStatus": "Open", "residentName": "Prasanna", "residentEmail": "prasanna_ramanujam@yahoo.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9916484134", "residentPhone": "91-9916484134", "aptId": "35991", "aptNo": "3F", "ownerEmail": "jyotimsingh@gmail.com", "isappuserresident": true, "ownerName": "Jyoti", "lockStatus": "Open", "residentName": "Jyoti", "residentEmail": "jyotimsingh@gmail.com", "comment": null, "towerName": "All" }, { "isappuserowner": true, "ownerPhone": "91-9606562707", "residentPhone": "91-9606562707", "aptId": "35992", "aptNo": "4F", "ownerEmail": "zfshaikh@gmail.com", "isappuserresident": true, "ownerName": "Sarah", "lockStatus": "Open", "residentName": "Sarah", "residentEmail": "zfshaikh@gmail.com", "comment": null, "towerName": "All" }], "societyId": "814", "count": 21, "type": "All" }, "message": "", "error": "", "status": "Success" }
// }

// Fetch society alert with localStorage caching

async function fetchAlertCountApi(data) {
  const response = await NeoAPI.getAlers(50, 1, data.type);
  return response;
  // {"societyId":814,"type":"current"}
  // {"response_data":{},"count":0,"message":"Invalid society Id or no alerts found","error":"Invalid society Id or no alerts found","status":"Failed"}
  // return { "response_data": {}, "count": 0, "message": "Invalid society Id or no alerts found", "error": "Invalid society Id or no alerts found", "status": "Failed" }
}

// Fetch society consumption Summary with localStorage caching
async function fetchConsumptionCountApi(inputData) {
  // NeoAPI.calculateTotalUsageFromPropertyData now expects YYYY-MM-DD and returns the full response structure.
  const response = await NeoAPI.getDaywiseTotalUsage(
    inputData.startdate,
    inputData.enddate
  );
  return response;
}

// async function fetchConsumptionCountApi(inputData) {

//   // Convert "YYYY-MM-DD" to "MM/DD/YYYY"
//   const formatForNeo = (dateStr) => {
//     const [yyyy, mm, dd] = dateStr.split("-");
//     return `${mm}/${dd}/${yyyy}`;
//   };

//   const startDateFormatted = formatForNeo(inputData.startdate);
//   const endDateFormatted = formatForNeo(inputData.enddate);

//   const totals = await NeoAPI.calculateTotalUsageFromPropertyData(startDateFormatted, endDateFormatted);
//   const property = NeoAPI.getPropertyData();

//   if (!totals || !property) {
//     return {
//       status: "fail",
//       reason: "No usage data or property info"
//     };
//   }

//   const data = Object.entries(totals).map(([ddmmyyyy, totalQtyRaw]) => {
//     const [dd, mm, yyyy] = ddmmyyyy.split("-");
//     const date = `${yyyy}-${mm}-${dd}`; // back to YYYY-MM-DD for output
//     return {
//       date,
//       totalQty: Math.round(totalQtyRaw / 1000)  // assuming milliliters to litres
//     };
//   });

//   const totalConsumption = data.reduce((sum, row) => sum + row.totalQty, 0);

//   return {
//     status: "Success",
//     response_data: {
//       unit: "litre",
//       data,
//       societyId: inputData.societyId,
//       societyName: property.property,
//       totalConsumption
//     },
//     message: "",
//     error: ""
//   };
//   // {"societyId":814,"startdate":"2025-06-01","enddate":"2025-06-30"}
//   // {"response_data":{"unit":"litre","data":[{"date":"2025-06-01","totalQty":8491},{"date":"2025-06-02","totalQty":9654},{"date":"2025-06-03","totalQty":8068},{"date":"2025-06-04","totalQty":8234},{"date":"2025-06-05","totalQty":6348},{"date":"2025-06-06","totalQty":6154},{"date":"2025-06-07","totalQty":6897},{"date":"2025-06-08","totalQty":5868},{"date":"2025-06-09","totalQty":6588},{"date":"2025-06-10","totalQty":6674},{"date":"2025-06-11","totalQty":6490},{"date":"2025-06-12","totalQty":6439},{"date":"2025-06-13","totalQty":7126},{"date":"2025-06-14","totalQty":7542},{"date":"2025-06-15","totalQty":6414},{"date":"2025-06-16","totalQty":6692},{"date":"2025-06-17","totalQty":6440},{"date":"2025-06-18","totalQty":6018},{"date":"2025-06-19","totalQty":5592},{"date":"2025-06-20","totalQty":6153},{"date":"2025-06-21","totalQty":5961},{"date":"2025-06-22","totalQty":5036},{"date":"2025-06-23","totalQty":6816}],"societyId":814,"totalConsumption":155695,"societyName":"Chelli Poise"},"message":"","error":"","status":"Success"}
//   // return { "response_data": { "unit": "litre", "data": [{ "date": "2025-06-01", "totalQty": 8491 }, { "date": "2025-06-02", "totalQty": 9654 }, { "date": "2025-06-03", "totalQty": 8068 }, { "date": "2025-06-04", "totalQty": 8234 }, { "date": "2025-06-05", "totalQty": 6348 }, { "date": "2025-06-06", "totalQty": 6154 }, { "date": "2025-06-07", "totalQty": 6897 }, { "date": "2025-06-08", "totalQty": 5868 }, { "date": "2025-06-09", "totalQty": 6588 }, { "date": "2025-06-10", "totalQty": 6674 }, { "date": "2025-06-11", "totalQty": 6490 }, { "date": "2025-06-12", "totalQty": 6439 }, { "date": "2025-06-13", "totalQty": 7126 }, { "date": "2025-06-14", "totalQty": 7542 }, { "date": "2025-06-15", "totalQty": 6414 }, { "date": "2025-06-16", "totalQty": 6692 }, { "date": "2025-06-17", "totalQty": 6440 }, { "date": "2025-06-18", "totalQty": 6018 }, { "date": "2025-06-19", "totalQty": 5592 }, { "date": "2025-06-20", "totalQty": 6153 }, { "date": "2025-06-21", "totalQty": 5961 }, { "date": "2025-06-22", "totalQty": 5036 }, { "date": "2025-06-23", "totalQty": 6816 }], "societyId": 814, "totalConsumption": 155695, "societyName": "Chelli Poise" }, "message": "", "error": "", "status": "Success" }
// }

// Fetch society pending bill with localStorage caching

function* fetchPendingBillApi(data) {
  //  {"societyId":814}
  //  {"response_data":{},"message":"No Bill Generated For This Society","error":"No Bill Generated For This Society","status":"Failed"}
  return {
    response_data: {},
    message: "No Bill Generated For This Society",
    error: "No Bill Generated For This Society",
    status: "Failed",
  };
}

// Fetch society getCollectionDetails with localStorage caching

async function fetchCollectionDetailsApi(data) {
  //   {"societyId":814}
  //   {"response_Data":{"data":[],"societyid":"814"},"message":"No collection info available for the society:814","error":"Invalid society Id.","status":"Failed"}
  // return {
  //   response_Data: { data: [], societyid: "814" },
  //   message: "No collection info available for the society:814",
  //   error: "Invalid society Id.",
  //   status: "Failed",
  // };

  const response = await NeoAPI.getWaterBillHistory(data.society_name);
  response.response_data = response.data;
  delete response.data;

  return response;
}

// Fetch society waterTanker with localStorage caching

function* fetchWaterTankerApi(data) {
  //{"society":814,"source":"commercial","month":"06","year":"2025"}
  //{"response_data":[],"total":0,"message":"No Data found","error":"Invalid Input","status":"Failed"}
  return {
    response_data: [],
    total: 0,
    message: "No Data found",
    error: "Invalid Input",
    status: "Failed",
  };
}

// Fetch society municipalWater with localStorage caching

function* fetchMunicipalWaterApi(data) {
  // {"society":814,"source":"municipal","month":"06","year":"2025"}
  // {"response_data":[],"total":0,"message":"No Data found","error":"Invalid Input","status":"Failed"}
  return {
    response_data: [],
    total: 0,
    message: "No Data found",
    error: "Invalid Input",
    status: "Failed",
  };
}

// Fetch society groundWater with localStorage caching

function* fetchGroundWaterApi(data) {
  // {"society":814,"source":"ground","month":"06","year":"2025"}
  // {"response_data":[],"total":0,"message":"No Data found","error":"Invalid Input","status":"Failed"}
  return {
    response_data: [],
    total: 0,
    message: "No Data found",
    error: "Invalid Input",
    status: "Failed",
  };
}

// Fetch society rainWater with localStorage caching

function* fetchRainWaterApi(data) {
  //{"society":814,"source":"rain","month":"06","year":"2025"}
  //{"response_data":[],"total":0,"message":"No Data found","error":"Invalid Input","status":"Failed"}

  return {
    response_data: [],
    total: 0,
    message: "No Data found",
    error: "Invalid Input",
    status: "Failed",
  };
}

// Fetch society getSlabRate with localStorage caching

function* fetchSlabRateApi(data) {
  const token = localStorage.getItem("fmsToken");

  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getslabrate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const slabRateResJson = yield response.json();

    return slabRateResJson;
  } catch (error) {
    throw error;
  }
}
// Post society insertRwaMembers

async function PostInsertRwaMembersApi(data) {
  var res = await NeoAPI.PostInsertRwaMembersApi(data);
  return res;

  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `SocRwaMembers_${fmsUser.society_id}`;

  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/insertrwamembers`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const responseJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   return responseJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch society aggregateConsumption with localStorage caching

function* fetchAggregateConsumptionApi(data) {
  //{"societyId":"814","month":"06","year":"2025"}
  //{"response_data":{"aptConsumption":0,"maxConsumption":0,"billingMonth":null,"minConsumption":0,"societyId":"814","societyConsumption":0,"aptId":null},"message":"","error":"","status":"Success"}
}

// Fetch society appUsers with localStorage caching

function* fetchAppUsersApi(data) {
  const response = NeoAPI.getAppUsers(data.aptId);
  return response;

  const token = localStorage.getItem("fmsToken");

  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/appusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const appUsersResJson = yield response.json();
    return appUsersResJson;
  } catch (error) {
    throw error;
  }
}

// Post society appUsers

function* PostAppUsersApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `apartment_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/addAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const responseJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return responseJson;
  } catch (error) {
    throw error;
  }
}

// Delete society appUsers

function* DeleteAppUsersApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `apartment_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/removeAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const responseJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return responseJson;
  } catch (error) {
    throw error;
  }
}

// Update society appUsers

function* UpdateAppUsersApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `apartment_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/addaptdetails`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const responseJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return responseJson;
  } catch (error) {
    throw error;
  }
}

// Post socMailSent

function* PostSocMailSentApi(data) {
  const token = localStorage.getItem("fmsToken");

  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/socmailsent`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const responseJson = yield response.json();
    return responseJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society isMailSent

function* fetchIsMailSentApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/ismailsent`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const ismailSentResJson = yield response.json();
    return ismailSentResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society isMailSent

function* fetchBillCycleDetailsApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/societydataservice/society/getbillcycledetail`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const billCycleDetailsResJson = yield response.json();
    return billCycleDetailsResJson;
  } catch (error) {
    throw error;
  }
}

// Post regenerate

function* PostRegenerateApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `getCollectionDetails_${fmsUser.society_id}`;
  const cacheKey1 = `consolidatedBill_${fmsUser.society_id}`;

  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/regenerate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const responseJson = yield response.json();
    localStorage.removeItem(cacheKey);
    localStorage.removeItem(cacheKey1);
    return responseJson;
  } catch (error) {
    throw error;
  }
}

// Post CreateSocBill

async function PostCreateSocBillApi(data) {
  const response = await NeoAPI.generateWaterBill(data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `getCollectionDetails_${fmsUser.society_id}`;
  // const cacheKey1 = `consolidatedBill_${fmsUser.society_id}`;
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/createsocbill`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const responseJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   localStorage.removeItem(cacheKey1);
  //   return responseJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post uploadPayment

async function PostUploadPaymentApi(data) {
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `getCollectionDetails_${fmsUser.society_id}`;
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/uploadpayment`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const responseJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   return responseJson;
  // } catch (error) {
  //   throw error;
  // }
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const responses = [];

  for (const item of data.payments) {
    const paymentData = {
      ...(item?.paymentamount
        ? { paidamount: Number(item.paymentamount) }
        : {}),
      ...(item?.adjustment ? { adjustment: Number(item.adjustment) } : {}),
      ...(item?.mode ? { payment_mode: item.mode } : {}),
    };

    const response = await NeoAPI.updateWaterBillPayment(
      fmsUser.society_name,
      item.aptNumber,
      paymentData
    );

    responses.push({
      aptNumber: item.aptNumber,
      ...response,
    });
  }

  return responses;
}

async function PostPaymentApi(data) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const responses = [];

  for (const item of data.payments) {
    const payment_epoch = Math.floor(
      new Date(item?.paymentdate).getTime() / 1000
    );

    const data = {
      property: fmsUser.society_name,
      userName: fmsUser.username,
      unitName: item.aptNumber,
      paid_amount: Number(item.paymentamount),
      payment_mode: item.mode,
      payment_epoch: payment_epoch,
    };

    const response = await NeoAPI.updatePaymentApi(data);

    responses.push({
      aptNumber: item.aptNumber,
      ...response,
    });
  }

  return responses;
}

// Fetch society appUsers with localStorage caching

async function fetchConsolidatedBillApi(data) {
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `consolidatedBill_${fmsUser.society_id}`;
  // const cached = localStorage.getItem(cacheKey);

  // if (cached) {
  //   try {
  //     return JSON.parse(cached);
  //   } catch (e) {
  //     console.warn("Corrupted cached consolidatedBill. Refetching...");
  //   }
  // }
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/consolidatedbill`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const consolidatedBillResJson = yield response.json();
  //   // localStorage.setItem(cacheKey, JSON.stringify(consolidatedBillResJson));

  //   return consolidatedBillResJson;
  // } catch (error) {
  //   throw error;
  // }

  const response = await NeoAPI.getWaterBill(
    data.society_name,
    data.aptNo,
    data.date
  );

  response.response_data = response.data;
  delete response.data;

  return response;
}

// Fetch society getConsolidatedByMonth with localStorage caching

function* fetchGetConsolidatedByMonthApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/societydataservice/society/getconsolidatedbymonth`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const ConsolidatedByMonthResJson = yield response.json();

    return ConsolidatedByMonthResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society getPayments with localStorage caching

async function fetchGetPaymentsApi(data) {
  const response = await NeoAPI.getPaymentsApi(data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/getpayments`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const getPaymentsResJson = yield response.json();

  //   return getPaymentsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch society pendingBill with localStorage caching

function* fetchCollectionPendingBillApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/pendingbill`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const pendingBillResJson = yield response.json();

    return pendingBillResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society getMeterWiseConsumption with localStorage caching

async function fetchGetMeterWiseConsumptionApi(data) {
  // Request from UI , 0 - current month , 1 - one month before , 2, two months before and so on.....
  function getMonthString(monOffset) {
    const now = new Date();
    now.setMonth(now.getMonth() - monOffset); // subtract months
    const month = String(now.getMonth() + 1).padStart(2, "0"); // JS months are 0-based
    const year = now.getFullYear();
    return `${month}-${year}`;
  }
  let month = getMonthString(parseInt(data.mon));
  return await NeoAPI.generateConsumptionSummary(month);

  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/getmeterwiseconsumption`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const getMeterWiseConsumptionResJson = yield response.json();

  //   return getMeterWiseConsumptionResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch society ValveStatus with localStorage caching

async function fetchValveStatusApi(data) {
  const neoValveStatusResponse = await NeoAPI.getValveStatusForUnit(data.aptId);
  return neoValveStatusResponse;

  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvestatus`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const ValveStatusResJson = yield response.json();

  //   return ValveStatusResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post society valve with localStorage caching

async function PostValveApi(data) {
  const neoValveOperateResponse = await NeoAPI.operateValve(
    data.meterId,
    data.action
  );
  return neoValveOperateResponse;
  // console.log(result);
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const ValveResJson = yield response.json();

  //   return ValveResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post society AllValveStatus with localStorage caching

function* PostAllValveStatusApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const AllValveResJson = yield response.json();

    return AllValveResJson;
  } catch (error) {
    throw error;
  }
}

// Post society admin lock with localStorage caching

async function PostAdminLockApi(data) {
  const response = await NeoAPI.adminLock(data?.societyName, data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `apartment_${fmsUser.society_id}`;
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvestate`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const adminLockResJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   return adminLockResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch society auto generate status with localStorage caching

function* fetchAutoGenerateStatusApi(data) {
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/autogeneratestatus`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const autoGenerateStatusResJson = yield response.json();

  //   return autoGenerateStatusResJson;
  // } catch (error) {
  //   throw error;
  // }
  const neoLoginResponse = {
    response_data: { societyId: "", autoGenerateStatus: 1 },
    error: "",
    message: "",
    status: "Success",
  };
  neoLoginResponse.response_data.societyId = data.societyId;
  return neoLoginResponse;
}

// Post society ViewAptBill with localStorage caching

function* PostViewAptBillApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/viewaptbill`,

      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const viewAptBillResJson = yield response.json();

    return viewAptBillResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society getTemplate with localStorage caching

function* fetchGetTemplateApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/gettemplate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const getTemplateResJson = yield response.json();

    return getTemplateResJson;
  } catch (error) {
    throw error;
  }
}

// Post society sendBills with localStorage caching

async function PostSendBillsApi(data) {
  const response = await NeoAPI.sendBills(data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/sendBills`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const sendBillsResJson = yield response.json();

  //   return sendBillsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post society sendBill with localStorage caching

function* PostSendBillApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/sendBill`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const sendBillResJson = yield response.json();

    return sendBillResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society valveHistory with localStorage caching

async function fetchValveHistoryApi(data) {
  const neoValveHistoryResponse = await NeoAPI.getValveHistoryForUnit(
    data.aptId
  );
  return neoValveHistoryResponse;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valvehistory`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const valveHistoryResJson = yield response.json();

  //   return valveHistoryResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Delete society removeAppUsers

function* RemoveAppUsersApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `apartment_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/removeAppusers`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const removeAppUserResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return removeAppUserResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch society interimBill with localStorage caching

function* fetchInterimBillApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/interimbill`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const interimBillResJson = yield response.json();

    return interimBillResJson;
  } catch (error) {
    throw error;
  }
}

// Post society collection Payments with localStorage caching

async function PostUpdatePaymentApi(data) {
  const response = await NeoAPI.updatePaymentApi(data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/billingservice/society/updatepayment`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const updatePaymentResJson = yield response.json();

  //   return updatePaymentResJson;
  // } catch (error) {
  //   throw error;
  // }
}
// Fetch society  current Alerts

async function FetchCurrentAlertApi(data) {
  const response = await NeoAPI.getAlers(50, 1, data.type);

  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/identityservice/society/alert`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const currentAlertResJson = yield response.json();

  //   return currentAlertResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch society  Alerts history

async function FetchAlertHistoryApi(data) {
  const response = await NeoAPI.getAlers(
    data.limit,
    data.page,
    data.type,
    data.aptNumber
  );

  return response;
}

// Fetch get Apartment type  history

function* FetchApartmentTypeApi(data) {
  const response = NeoAPI.getUnits();

  return response;
}

// Post AlertValveAction   history

function* PostAlertValveActionApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      let errJSON = {};
      try {
        errJSON = yield response.json();
      } catch {}
      throw Object.assign(response, errJSON);
    }
    const alertValveActionResJson = yield response.json();

    return alertValveActionResJson;
  } catch (error) {
    throw error;
  }
}

// Post society water tanker add

function* PostWaterTankerAddWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `waterTanker_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const waterTankerAddResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return waterTankerAddResJson;
  } catch (error) {
    throw error;
  }
}

// Patch society water tanker

function* PatchWaterTankerApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `waterTanker_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const waterTankerUpdateResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return waterTankerUpdateResJson;
  } catch (error) {
    throw error;
  }
}

// Delete society water tanker

function* DeleteWaterTankerApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `waterTanker_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const waterTankerDeleteResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return waterTankerDeleteResJson;
  } catch (error) {
    throw error;
  }
}

// Post society municipal water add

function* PostMunicipalWaterAddApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `municipalWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const municipalWaterAddResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return municipalWaterAddResJson;
  } catch (error) {
    throw error;
  }
}

// Patch society municipal water

function* PatchMunicipalWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `municipalWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const municipalWaterUpdateResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return municipalWaterUpdateResJson;
  } catch (error) {
    throw error;
  }
}

// Patch society municipal water

function* DeleteMunicipalWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `municipalWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const municipalWaterDeleteResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return municipalWaterDeleteResJson;
  } catch (error) {
    throw error;
  }
}

// Post society Rain water add

function* PostRainWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `rainWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const rainWaterAddResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return rainWaterAddResJson;
  } catch (error) {
    throw error;
  }
}

// Post society Rain water add

function* PatchRainWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `rainWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const rainWaterUpdateResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return rainWaterUpdateResJson;
  } catch (error) {
    throw error;
  }
}

// Delete society Rain water

function* DeleteRainWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `rainWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const rainWaterDeleteResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return rainWaterDeleteResJson;
  } catch (error) {
    throw error;
  }
}

// Post society ground water add

function* PostGroundWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `groundWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/addWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const groundWaterAddResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return groundWaterAddResJson;
  } catch (error) {
    throw error;
  }
}

// Patch society ground water add

function* PatchGroundWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `groundWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/editWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const groundWaterUpdateResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return groundWaterUpdateResJson;
  } catch (error) {
    throw error;
  }
}

// Delete society ground water add

function* DeleteGroundWaterApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `groundWater_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/waterpurchaseservice/watersource/deleteWater`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const groundWaterDeleteResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return groundWaterDeleteResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch  society invoice

async function FetchInvoiceApi(data) {
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     ${appConfig.urlPrefixIp}/societydataservice/society/invoice,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: Bearer ${token},
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const InvoiceResJson = yield response.json();
  //   return InvoiceResJson;
  // } catch (error) {
  //   throw error;
  // }

  const response = await NeoAPI.getInvoices(data.societyId);
  response.response_data = response.data;
  delete response.data;
  return response;
}

// Fetch  society invoice ledger

async function FetchInvoiceLedgerApi(data) {
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     ${appConfig.urlPrefixIp}/billingservice/society/ledger,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: Bearer ${token},
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const InvoiceLedgerResJson = yield response.json();
  //   return InvoiceLedgerResJson;
  // } catch (error) {
  //   throw error;
  // }

  const response = await NeoAPI.getInvoicePDF(data.value);
  // response.response_data = response.data;
  // delete response.data;
  return response;
}

// Fetch  society invoice payments

function* FetchInvoicePaymentsApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/invoicepayments`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const InvoicePaymentResJson = yield response.json();
    return InvoicePaymentResJson;
  } catch (error) {
    throw error;
  }
}

// Post  society invoice payments

function* PostInvoicePaymentsApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/billingservice/society/addinvpayment`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      try {
        yield response.json();
      } catch {}
      throw response;
    }
    const postInvoicePaymentResJson = yield response.json();
    return postInvoicePaymentResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch  society support tickets

async function FetchSupportTicketsApi(data) {
  const response = await NeoAPI.getAllTickets(data.societyName);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/alltickets`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const supportTicketsResJson = yield response.json();
  //   return supportTicketsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post  society support tickets

async function PostSupportTicketsApi(data) {
  const response = await NeoAPI.createTicket(data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/createticket`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: data,
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const postSupportTicketsResJson = yield response.json();
  //   return postSupportTicketsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch  society support tickets

async function FetchSupportTicketsByIdApi(data) {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const response = await NeoAPI.getTicketById(societyName, data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/ticket`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const supportTicketsByIdResJson = yield response.json();
  //   return supportTicketsByIdResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch  society support tickets conversation

async function FetchSupportTicketsConversationApi(data) {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const response = await NeoAPI.getChatHistory(societyName, data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/ticketconversation`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const supportTicketsConversationResJson = yield response.json();
  //   return supportTicketsConversationResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post  society support tickets reply

async function PostSupportTicketsReplyApi(data) {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const response = await NeoAPI.createTicketReply(societyName, data);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/ticketreply`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: data,
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const postSupportTicketsReplyResJson = yield response.json();
  //   return postSupportTicketsReplyResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch  society support agents

async function FetchSupportAgentsApi() {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const response = await NeoAPI.getSupportAgents(societyName);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `agents_${fmsUser.society_id}`;
  // const cached = localStorage.getItem(cacheKey);

  // if (cached) {
  //   try {
  //     return JSON.parse(cached);
  //   } catch (e) {
  //     console.warn("Corrupted cached agents. Refetching...");
  //   }
  // }
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/agents`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: data ? data : null,
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const supportAgentsResJson = yield response.json();

  //   localStorage.setItem(cacheKey, JSON.stringify(supportAgentsResJson));
  //   return supportAgentsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch  society support Contacts

async function FetchSupportContactsApi() {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const response = await NeoAPI.getSupportContacts(societyName);
  return response;
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `contacts_${fmsUser.society_id}`;
  // const cached = localStorage.getItem(cacheKey);
  // if (cached) {
  //   try {
  //     return JSON.parse(cached);
  //   } catch (e) {
  //     console.warn("Corrupted cached contacts. Refetching...");
  //   }
  // }
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/watersourceservice/society/contacts`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: data ? data : null,
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const supportContactsResJson = yield response.json();
  //   localStorage.setItem(cacheKey, JSON.stringify(supportContactsResJson));

  //   return supportContactsResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Post Recover password

function* PostRecoverPassApi(data) {
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/recoverpass`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      let errJSON = {};
      try {
        errJSON = yield response.json();
      } catch {}
      throw Object.assign(response, errJSON);
    }
    const recoverPassResJson = yield response.json();
    return recoverPassResJson;
  } catch (error) {
    throw error;
  }
}

// Post reset password

function* PostResetPassApi(data) {
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/user/updatePassword`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      let errJSON = {};
      try {
        errJSON = yield response.json();
      } catch {}
      throw Object.assign(response, errJSON);
    }
    const resetPassResJson = yield response.json();
    return resetPassResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch RWA Members

async function FetchRwaMembersApi(data) {
  var res = await NeoAPI.getManagementTeam(data.societyId);
  return res;
  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `SocRwaMembers_${fmsUser.society_id}`;
  // const cached = localStorage.getItem(cacheKey);
  // if (cached) {
  //   try {
  //     return JSON.parse(cached);
  //   } catch (e) {
  //     console.warn("Corrupted cached rwa members. Refetching...");
  //   }
  // }
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getrwamembers`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const rwaMembersResJson = yield response.json();
  //   localStorage.setItem(cacheKey, JSON.stringify(rwaMembersResJson));
  //   return rwaMembersResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Delete RWA Members

async function DeleteRwaMembersApi(data) {
  var res = await NeoAPI.DeleteRwaMembersApi(data);
  return res;

  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `SocRwaMembers_${fmsUser.society_id}`;
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/deleterwamember`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const DeleteRwaMembersResJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   return DeleteRwaMembersResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Update RWA Members

async function UpdateRwaMembersApi(data) {
  var res = await NeoAPI.UpdateRwaMembersApi(data);
  return res;

  // const token = localStorage.getItem("fmsToken");
  // const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  // const cacheKey = `SocRwaMembers_${fmsUser.society_id}`;
  // try {
  //   const response = yield fetch(
  //     `${appConfig.urlPrefixIp}/apartmentinfoservice/society/updaterwamember`,
  //     {
  //       method: "POST",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //         type: "Web",
  //       },
  //       body: JSON.stringify(data),
  //     }
  //   );
  //   if (!response.ok) {
  //     throw response;
  //   }
  //   const UpdateRwaMembersResJson = yield response.json();
  //   localStorage.removeItem(cacheKey);
  //   return UpdateRwaMembersResJson;
  // } catch (error) {
  //   throw error;
  // }
}

// Fetch fixed charge

function* FetchFixedChargeApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `fixedCharge_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached fixed charge. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getfixedcharge`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fixedChargeResJson = yield response.json();
    localStorage.setItem(cacheKey, JSON.stringify(fixedChargeResJson));
    return fixedChargeResJson;
  } catch (error) {
    throw error;
  }
}

// Patch fixed monthly charge

function* PatchFixedMonthlyChargeApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `fixedCharge_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updatefixedcharge`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fixedMonthlyChargeResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return fixedMonthlyChargeResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch adjustments

function* FetchAdjustmentApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `adjustments_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached adjustments. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getadjustments`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchAdjustmentResJson = yield response.json();
    localStorage.setItem(cacheKey, JSON.stringify(fetchAdjustmentResJson));
    return fetchAdjustmentResJson;
  } catch (error) {
    throw error;
  }
}

// Post add adjustments

function* PostAdjustmentApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `adjustments_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/addadjustments`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const postAdjustmentResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return postAdjustmentResJson;
  } catch (error) {
    throw error;
  }
}

// Patch water Report card

function* PatchWaterReportCard(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/autogenerate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchWaterReportCardResJson = yield response.json();
    return patchWaterReportCardResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch Quota Not Set Apt

function* FetchQuotaNotSetAptApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `quotaNotSetApts_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached quota not set. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/quotanotsetapts`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const quotaNotSetResJson = yield response.json();
    localStorage.setItem(cacheKey, JSON.stringify(quotaNotSetResJson));
    return quotaNotSetResJson;
  } catch (error) {
    throw error;
  }
}

// Post Set Quota

function* PostSetQuotaApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `quotaNotSetApts_${fmsUser.society_id}`;
  const cacheKey1 = `quotaSetApts_${fmsUser.society_id}`;

  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/setquota`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const PostSetQuotaResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    localStorage.removeItem(cacheKey1);
    return PostSetQuotaResJson;
  } catch (error) {
    throw error;
  }
}

// Patch Update Quota

function* PatchUpdateQuotaApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `quotaSetApts_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updatequota`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const PatchUpdateQuotaResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return PatchUpdateQuotaResJson;
  } catch (error) {
    throw error;
  }
}

// Post reset Quota

function* PostResetQuotaApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `quotaNotSetApts_${fmsUser.society_id}`;
  const cacheKey1 = `quotaSetApts_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/resetquota`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const postResetQuotaResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    localStorage.removeItem(cacheKey1);
    return postResetQuotaResJson;
  } catch (error) {
    throw error;
  }
}

// Update apartment

function* PatchUpdateApartmentApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/setapttype`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchUpdateApartmentResJson = yield response.json();
    return patchUpdateApartmentResJson;
  } catch (error) {
    throw error;
  }
}

// Update society Admin

function* PatchSocietyAdminApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `socProfile_${fmsUser.society_id}`;
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/updateadmin`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchSocietyAdminResJson = yield response.json();
    localStorage.removeItem(cacheKey);
    return patchSocietyAdminResJson;
  } catch (error) {
    throw error;
  }
}

// Update Template

function* PatchUpdateTemplateApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/settemplate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchUpdateTemplateResJson = yield response.json();
    return patchUpdateTemplateResJson;
  } catch (error) {
    throw error;
  }
}

// Patch soc contact details

function* PatchSocContactsApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/societydataservice/society/updatesoccontact`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchSocContactsResJson = yield response.json();
    return patchSocContactsResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch apartment quota

function* FetchApartmentQuotaApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `quotaSetApts_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached quota not set. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getaptquota`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchApartmentQuotaResJson = yield response.json();
    localStorage.setItem(cacheKey, JSON.stringify(fetchApartmentQuotaResJson));
    return fetchApartmentQuotaResJson;
  } catch (error) {
    throw error;
  }
}

// Patch slabRate

function* PatchSlabRateApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updateslabrate`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const patchSlabRateResJson = yield response.json();
    return patchSlabRateResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch retrieve

function* FetchRetrieveApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/identityservice/society/contact/retrieve`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchRetrieveResJson = yield response.json();
    return fetchRetrieveResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch cafserial

function* FetchCafserialApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/cafserial`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchcafserialResJson = yield response.json();
    return fetchcafserialResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch cafserial info

function* FetchCafserialInfoApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/cafserialinfo`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchcafserialInfoResJson = yield response.json();
    return fetchcafserialInfoResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch Onboarding apartment

function* FetchOnboardingApartmentApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchOnboardingApartmentResJson = yield response.json();
    return fetchOnboardingApartmentResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch profileByID

function* FetchprofileByIDApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `SocProfileById_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached soc profile by id. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/profile/society/id/${fmsUser.society_id}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchProfileByIDResJson = yield response.json();
    return fetchProfileByIDResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch onboarding Residents apartment

function* FetchOnboardingResApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const fetchOnboardingResidentsResJson = yield response.json();
    return fetchOnboardingResidentsResJson;
  } catch (error) {
    throw error;
  }
}

// Post approve Residents apartment

function* PostApproveAptsApi(data) {
  const token = localStorage.getItem("fmsToken");
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/apartmentinfoservice/society/approveapts`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const postApproveAptsResJson = yield response.json();
    return postApproveAptsResJson;
  } catch (error) {
    throw error;
  }
}

// Fetch SOC

function* FetchSocApi(data) {
  const token = localStorage.getItem("fmsToken");
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cacheKey = `getSoc_${fmsUser.society_id}`;
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn("Corrupted cached getSoc. Refetching...");
    }
  }
  try {
    const response = yield fetch(
      `${appConfig.urlPrefixIp}/societydataservice/society/getsoc`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          type: "Web",
        },
        body: JSON.stringify(data),
      }
    );
    if (!response.ok) {
      throw response;
    }
    const FetchSocResJson = yield response.json();
    localStorage.setItem(cacheKey, JSON.stringify(FetchSocResJson));
    return FetchSocResJson;
  } catch (error) {
    throw error;
  }
}

//Fetch water bill settings
async function WaterBillSettingsApi(data) {
  const response = await NeoAPI.waterBillSettings(
    data.societyName,
    data.settingsData
  );
  return response;
}

//Fetch water purchase
async function WaterPurchaseApi(data) {
  const response = await NeoAPI.getSourceEntries(
    data.society,
    data.from,
    data.to
  );
  return response;
}

async function AddWaterPurchaseApi(data) {
  const response = await NeoAPI.addSourceEntries(
    data.society,
    data.WaterSourceEntry
  );
  return response;
}

async function fetchApartmentByUnitApi(data) {
  const response = await NeoAPI.getApartmentByUnit(
    data.societyName,
    data.aptName
  );
  return response;
}

async function updateResidentDataApi(data) {
  const response = await NeoAPI.updateResidentData(
    data.societyName,
    data.residentData
  );
  return response;
}

async function getUnitsData(data) {
  const response = await NeoAPI._getUnits(data);
  return response;
}

async function fmUserApi(data) {
  const response = await NeoAPI.getFmUsers(data);
  return response;
}

async function SourceMeterReadingsApi(data) {
  const response = await NeoAPI.getSourceMeterReadings(data);
  return response;
}

async function fetchLogOutApi(data) {
  const response = await NeoAPI.logout(data);
  return response;

  // return {
  //   response_data: [],
  //   total: 0,
  //   message: "No Data found",
  //   error: "Invalid Input",
  //   status: "Failed",
  // };
}

export default {
  postLogInApi,
  fetchProfileApi,
  fetchRwaStatusApi,
  fetchApartmentCountApi,
  fetchAlertCountApi,
  fetchConsumptionCountApi,
  fetchPendingBillApi,
  fetchCollectionDetailsApi,
  fetchWaterTankerApi,
  fetchMunicipalWaterApi,
  fetchRainWaterApi,
  fetchGroundWaterApi,
  fetchSlabRateApi,
  PostInsertRwaMembersApi,
  fetchAggregateConsumptionApi,
  fetchAppUsersApi,
  PostAppUsersApi,
  DeleteAppUsersApi,
  UpdateAppUsersApi,
  PostSocMailSentApi,
  fetchIsMailSentApi,
  fetchBillCycleDetailsApi,
  PostRegenerateApi,
  PostCreateSocBillApi,
  PostUploadPaymentApi,
  fetchConsolidatedBillApi,
  fetchGetConsolidatedByMonthApi,
  fetchGetPaymentsApi,
  fetchCollectionPendingBillApi,
  fetchGetMeterWiseConsumptionApi,
  fetchValveStatusApi,
  PostValveApi,
  PostAllValveStatusApi,
  PostAdminLockApi,
  fetchAutoGenerateStatusApi,
  PostViewAptBillApi,
  fetchGetTemplateApi,
  PostSendBillsApi,
  PostSendBillApi,
  fetchValveHistoryApi,
  RemoveAppUsersApi,
  fetchInterimBillApi,
  PostUpdatePaymentApi,
  FetchCurrentAlertApi,
  FetchAlertHistoryApi,
  FetchApartmentTypeApi,
  PostAlertValveActionApi,
  PostWaterTankerAddWaterApi,
  PatchWaterTankerApi,
  DeleteWaterTankerApi,
  PostMunicipalWaterAddApi,
  PatchMunicipalWaterApi,
  DeleteMunicipalWaterApi,
  PostRainWaterApi,
  PatchRainWaterApi,
  DeleteRainWaterApi,
  PostGroundWaterApi,
  PatchGroundWaterApi,
  DeleteGroundWaterApi,
  FetchInvoiceApi,
  FetchInvoiceLedgerApi,
  FetchInvoicePaymentsApi,
  PostInvoicePaymentsApi,
  FetchSupportTicketsApi,
  PostSupportTicketsApi,
  FetchSupportTicketsByIdApi,
  FetchSupportTicketsConversationApi,
  PostSupportTicketsReplyApi,
  FetchSupportAgentsApi,
  FetchSupportContactsApi,
  PostRecoverPassApi,
  PostResetPassApi,
  FetchRwaMembersApi,
  DeleteRwaMembersApi,
  UpdateRwaMembersApi,
  FetchFixedChargeApi,
  PatchFixedMonthlyChargeApi,
  FetchAdjustmentApi,
  PostAdjustmentApi,
  PatchWaterReportCard,
  FetchQuotaNotSetAptApi,
  PostSetQuotaApi,
  PatchUpdateQuotaApi,
  PostResetQuotaApi,
  PatchUpdateApartmentApi,
  PatchSocietyAdminApi,
  PatchUpdateTemplateApi,
  PatchSocContactsApi,
  FetchApartmentQuotaApi,
  PatchSlabRateApi,
  FetchRetrieveApi,
  FetchCafserialApi,
  FetchCafserialInfoApi,
  FetchOnboardingApartmentApi,
  FetchprofileByIDApi,
  FetchOnboardingResApi,
  PostApproveAptsApi,
  FetchSocApi,
  fetchLogOutApi,
  WaterBillSettingsApi,
  WaterPurchaseApi,
  fetchApartmentByUnitApi,
  updateResidentDataApi,
  AddWaterPurchaseApi,
  getUnitsData,
  fmUserApi,
  SourceMeterReadingsApi,
  PostPaymentApi,
};
